import { Component, Input, type OnInit } from '@angular/core'
import { BdcContentV2Service, BdcFacilityState } from '@tokeet-frontend/channel-content'
import { combineLatest } from 'rxjs'
import * as lodash from 'lodash'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'
import { finalize } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { ActionFailed, Toaster } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-bdc-property-amenities',
  templateUrl: './bdc-property-amenities.component.html',
  styleUrls: ['./bdc-property-amenities.component.scss'],
})
export class BdcPropertyAmenitiesComponent implements OnInit {
  @Input() propertyId: number

  amenitiesForm = this.fb.group({
    amenities: this.fb.array([]),
  })

  get amenitiesArray() {
    return this.amenitiesForm.get('amenities') as FormArray
  }

  isLoading = true
  constructor(
    private fb: FormBuilder,
    private toaster: Toaster,
    private store: Store<any>,
    private contentService: BdcContentV2Service
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.contentService.getPropertyAmenities(),
      this.contentService.getPropertyFacilities(this.propertyId),
    ])
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        ([amenities, facilities]) => {
          this.amenitiesArray.clear()
          const facilitiesById = lodash.keyBy(facilities, (f) => f.facility_id) as any

          lodash
            .sortBy(amenities, (t) => t.facility_name)
            .forEach((a) => {
              const f = facilitiesById[a.facility_id]
              this.amenitiesArray.push(
                this.fb.group({
                  id: a.facility_id,
                  name: a.facility_name,
                  enabled: /present/i.test(f?.state || ''),
                })
              )
            })
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onToggleItem(item: FormGroup, checked: boolean) {
    const id = item.value.id
    const data = {
      facility_id: id,
      state: checked ? BdcFacilityState.PRESENT : BdcFacilityState.MISSING,
    }
    this.contentService.updatePropertyFacilities(this.propertyId, [data]).subscribe(
      () => {
        this.toaster.success($localize`Amenities updated successfully`)
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  onSave() {
    const data = this.amenitiesArray.value.map((a: any) => ({
      facility_id: a.id,
      state: a.enabled ? BdcFacilityState.PRESENT : BdcFacilityState.MISSING,
    }))
    this.contentService.updatePropertyFacilities(this.propertyId, data).subscribe(
      () => {
        this.toaster.success($localize`Amenities updated successfully`)
      },
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }
}
